module.exports = __webpack_public_path__ + "static/media/Gallade_gaussian2.bc3a8809.png";